import { IPageData } from '../../models/analytics';
import { setPageDetails } from '../analytics';

const BASE = 'account>track business spend';
const MAML = 'maml:track business spend';
const MY_ACCOUNT = 'my account';

/**
 * Page analtyics for business tools
 */

export const setBusinessToolsPageAnalytics = () => {
  const purchaseHistoryPageData: IPageData = {
    pageInfo: {
      pageName: BASE,
      pageType: MAML,
    },
    category: {
      primaryCategory: MY_ACCOUNT,
      subCategory1: BASE,
      subCategory2: BASE,
    },
  };
  setPageDetails(purchaseHistoryPageData);
};
